import React from 'react';
import classnames from 'classnames';
import get from 'lodash/get';
import { LoveHeart } from '../../LoveMeter';
import MeasuredStage from '../_partials/MeasuredStage';
import { MeasuredCookieType } from '../../Measured';
import Duperswiper from '../_partials/Duperswiper';
import StageBackground from '../../DeviationBackground/StageBackground';
import DeviationFullView from '../../DeviationViews/Full';
import { BiDataHook } from '../../biLogger';
import s from './MobileArtStage.scss';
export var MobileArtStage = function (_a) {
    var className = _a.className, deviation = _a.deviation;
    return (React.createElement("div", { className: classnames(className, s['root']), "data-hook": BiDataHook.DEVIATION_ART_STAGE },
        React.createElement(MeasuredStage, { cookieType: MeasuredCookieType.DEVIATION_ARTSTAGE, cookieDim: "both" }, function (_a) {
            var containerSize = _a.containerSize, contentSize = _a.contentSize;
            return (React.createElement(Duperswiper, { key: deviation.deviationId, deviation: deviation, height: get(containerSize, 'height'), width: get(containerSize, 'width') }, function (dev) { return (React.createElement(React.Fragment, null,
                React.createElement(StageBackground, { deviation: dev }),
                React.createElement(DeviationFullView, { deviation: dev, height: get(contentSize, 'height'), width: get(contentSize, 'width') }))); }));
        }),
        React.createElement(LoveHeart, null)));
};
MobileArtStage.displayName = 'MobileArtStage';
export default MobileArtStage;
//# sourceMappingURL=MobileArtStage.js.map